/* Non-PII form funnel milestones for Clarity. Values remain masked. */
(function () {
  'use strict';
  if (window.__nhlFormFunnel) return;
  window.__nhlFormFunnel = true;

  var sent = Object.create(null);
  var pending = [];
  var pageStartedAt = Date.now();
  var active = Object.create(null);
  var TIMING_PREFIX = 'nhl:funnel:timing:v1:';

  function dispatch(name) {
    if (!name || sent[name]) return;
    sent[name] = true;
    if (typeof window.clarity === 'function') {
      try { window.clarity('event', name); return; } catch (_) {}
    }
    pending.push({ type: 'event', name: name });
  }

  function setTag(name, value) {
    if (!name || !value) return;
    if (typeof window.clarity === 'function') {
      try { window.clarity('set', name, value); return; } catch (_) {}
    }
    pending.push({ type: 'set', name: name, value: value });
  }

  function flush() {
    if (typeof window.clarity !== 'function' || !pending.length) return;
    var queue = pending;
    pending = [];
    queue.forEach(function (item) {
      try {
        if (item.type === 'set') window.clarity('set', item.name, item.value);
        else window.clarity('event', item.name);
      } catch (_) { pending.push(item); }
    });
  }

  function safeSlug(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 40);
  }

  function safeTagValue(value, fallback) {
    var result = String(value || '').replace(/[^a-zA-Z0-9_. -]+/g, '_').slice(0, 80);
    return result || fallback || 'unknown';
  }

  function timeBucket(milliseconds) {
    if (!Number.isFinite(milliseconds) || milliseconds < 0) return 'unknown';
    if (milliseconds < 10000) return 'under_10s';
    if (milliseconds < 30000) return '10_30s';
    if (milliseconds < 120000) return '30_120s';
    return '120s_plus';
  }

  function journeyPage(pathname) {
    var path = String(pathname || location.pathname).replace(/\/+$/, '') || '/';
    path = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/';
    if (path === '/') return 'home';
    if (path === '/pages/gallery') return 'gallery';
    if (path === '/pages/custom-watches') return 'custom_watches';
    if (path === '/pages/commission') return 'commission';
    if (path === '/pages/contact-us') return 'contact';
    if (/^\/collections\//.test(path)) return 'catalogue';
    if (/^\/products\//.test(path)) return 'product';
    return 'other';
  }

  function emitJourneyContext() {
    var page = journeyPage();
    setTag('journey_page', page);
    if (page !== 'other') dispatch('journey_' + page + '_viewed');
  }

  function applyAttributionTags() {
    var touch = null;
    try {
      var saved = JSON.parse(localStorage.getItem('nhl:inquiry:attribution:v1') || 'null');
      touch = saved && saved.last;
    } catch (_) {}
    var values = touch && Array.isArray(touch.values) ? touch.values : [];
    var clicks = touch && Array.isArray(touch.googleClicks) ? touch.googleClicks : [];
    setTag('traffic_source', safeTagValue(values[0], 'direct'));
    setTag('traffic_medium', safeTagValue(values[1], 'none'));
    setTag('traffic_campaign', safeTagValue(values[2], 'none'));
    setTag('traffic_placement', safeTagValue(values[5], 'none'));
    setTag('landing_path', safeTagValue(touch && touch.landingPath, safeTagValue(location.pathname, 'unknown')));
    setTag('google_click_id_present', clicks.some(function (value) { return !!value; }) ? 'yes' : 'no');
  }

  function trackGlobalLinks() {
    document.addEventListener('click', function (event) {
      var anchor = event.target.closest && event.target.closest('a');
      if (!anchor) return;
      var href = anchor.getAttribute('href') || '';
      if (/^mailto:/i.test(href)) { dispatch('contact_email_clicked'); return; }
      if (/^tel:/i.test(href)) { dispatch('contact_phone_clicked'); return; }
      var url;
      try { url = new URL(href, location.href); } catch (_) { return; }
      if (/instagram\.com$/i.test(url.hostname) || /\.instagram\.com$/i.test(url.hostname)) {
        dispatch('contact_instagram_clicked');
        return;
      }
      if (url.origin !== location.origin) return;
      var destination = journeyPage(url.pathname);
      if (destination !== 'other' && destination !== journeyPage()) {
        dispatch('journey_cta_to_' + destination + '_clicked');
      }
    });
  }

  function timingKey(prefix) {
    return TIMING_PREFIX + prefix + ':' + location.pathname;
  }

  function readTiming(prefix) {
    try {
      var record = JSON.parse(sessionStorage.getItem(timingKey(prefix)) || 'null');
      if (!record || !Number.isFinite(record.pageAt) || Date.now() - record.pageAt > 1800000) return null;
      return record;
    } catch (_) { return null; }
  }

  function writeTiming(prefix, state) {
    try {
      sessionStorage.setItem(timingKey(prefix), JSON.stringify({
        pageAt: pageStartedAt,
        startedAt: state.startedAt || 0,
        detailsAt: state.detailsAt || 0,
        submitClickedAt: state.submitClickedAt || 0,
        submittedAt: state.submittedAt || 0,
        lastStep: state.lastStep || 'none',
        submitClicks: state.submitClicks || 0
      }));
    } catch (_) {}
  }

  function applyTimingTags(prefix, record) {
    if (!record) return;
    if (record.startedAt) setTag(prefix + '_time_to_start', timeBucket(record.startedAt - record.pageAt));
    if (record.detailsAt && record.startedAt) setTag(prefix + '_time_to_details', timeBucket(record.detailsAt - record.startedAt));
    if (record.submittedAt && record.startedAt) setTag(prefix + '_time_to_submit', timeBucket(record.submittedAt - record.startedAt));
    setTag(prefix + '_last_step', safeTagValue(record.lastStep, 'none'));
    if (record.submitClicks > 1) dispatch(prefix + '_duplicate_submit');
  }

  function pendingInquiryRecord(formId) {
    var path = location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/pages\/)/i, '');
    var keys = [
      'nhl:lead:pending:v2:' + formId + ':' + path,
      'nhl:lead:pending:' + formId + ':' + location.pathname
    ];
    for (var i = 0; i < keys.length; i++) {
      try {
        var record = JSON.parse(sessionStorage.getItem(keys[i]) || 'null');
        if (record && /^NHL-[0-9a-f-]{36}$/i.test(record.id || '')) return record;
      } catch (_) {}
    }
    return null;
  }

  function fieldKey(field) {
    if (!field) return 'required_field';
    var name = field.name || '';
    if (name === 'contact[email]') return 'email';
    if (name === 'contact[name]') return 'name';
    if (name === 'contact[body]') return 'message';
    if (field.dataset && field.dataset.label) return safeSlug(field.dataset.label);
    var group = field.closest && field.closest('[data-step]');
    if (group) return safeSlug(group.getAttribute('data-step')) || 'configuration';
    return 'required_field';
  }

  function markStep(state, prefix, step) {
    state.lastStep = safeSlug(step) || 'unknown';
    setTag(prefix + '_last_step', state.lastStep);
    writeTiming(prefix, state);
  }

  function bind(form, prefix) {
    if (!form || form.__nhlFunnelBound) return;
    form.__nhlFunnelBound = true;
    var state = { startedAt: 0, detailsAt: 0, submitClickedAt: 0, submittedAt: 0, lastStep: 'none', submitClicks: 0, submitAttempted: false, success: false };
    active[prefix] = state;
    setTag('funnel_form', prefix);
    dispatch(prefix + '_viewed');

    var success = !!form.querySelector('.comm-success, .tick-row');
    if (success) {
      state.success = true;
      dispatch(prefix + '_form_success');
      var timing = readTiming(prefix);
      applyTimingTags(prefix, timing);
      setTag(prefix + '_status', 'success');
      var inquiry = pendingInquiryRecord(form.id);
      if (inquiry) setTag('inquiry_id', inquiry.id);
    }

    var serverError = !!form.querySelector('.comm-errors, [role="alert"]');
    if (serverError) {
      dispatch(prefix + '_form_error');
      dispatch(prefix + '_server_error');
      setTag(prefix + '_error_type', 'shopify_form_error');
    }

    function start() {
      if (state.startedAt) return;
      state.startedAt = Date.now();
      dispatch(prefix + '_started');
      setTag(prefix + '_time_to_start', timeBucket(state.startedAt - pageStartedAt));
      markStep(state, prefix, 'starting_point');
    }

    form.addEventListener('focusin', function (event) {
      var field = event.target.closest && event.target.closest('input, select, textarea');
      if (!field || field.type === 'hidden') return;
      start();
      if (prefix === 'commission' && field.closest('#comm-details')) {
        if (!state.detailsAt) {
          state.detailsAt = Date.now();
          dispatch('commission_details_started');
          setTag('commission_time_to_details', timeBucket(state.detailsAt - state.startedAt));
        }
        markStep(state, prefix, 'details');
      }
      if (prefix === 'contact' && field.name === 'contact[body]') {
        dispatch('contact_message_started');
        markStep(state, prefix, 'message');
      }
    });

    form.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.type === 'hidden') return;
      start();
      if (prefix !== 'commission') return;
      var group = target.closest('[data-step]');
      var step = group && safeSlug(group.getAttribute('data-step'));
      if (step) {
        dispatch('commission_step_' + step + '_selected');
        markStep(state, prefix, step);
      }
      if (target.dataset.label === 'Build type') dispatch('commission_build_type_selected');
      if (target.closest('[data-key="quantity"]')) dispatch('commission_quantity_selected');
    });

    form.addEventListener('click', function (event) {
      var target = event.target;
      var submit = target.closest && target.closest('button[type="submit"], input[type="submit"]');
      if (submit) {
        start();
        state.submitClicks++;
        state.submitClickedAt = Date.now();
        dispatch(prefix + '_submit_clicked');
        if (state.submitClicks > 1) dispatch(prefix + '_duplicate_submit');
        writeTiming(prefix, state);
      }
      if (prefix !== 'commission') return;
      if (target.closest('[data-skip-to-details]')) {
        dispatch('commission_skip_to_details');
        markStep(state, prefix, 'details');
      }
      var card = target.closest('[data-start] .comm-start-card');
      if (card) {
        dispatch('commission_starting_point_selected');
        markStep(state, prefix, 'starting_point');
      }
      var toggle = target.closest('[data-collapsible] [data-toggle]');
      if (toggle) {
        var stepGroup = toggle.closest('[data-step]');
        var stepName = stepGroup && safeSlug(stepGroup.getAttribute('data-step'));
        if (stepName) {
          dispatch('commission_step_' + stepName + '_opened');
          markStep(state, prefix, stepName);
        }
      }
      if (target.closest('[data-expand-all]')) dispatch('commission_show_every_option');
    });

    form.addEventListener('invalid', function (event) {
      var key = fieldKey(event.target);
      dispatch(prefix + '_validation_error');
      dispatch(prefix + '_invalid_' + key);
      setTag(prefix + '_validation_field', key);
      markStep(state, prefix, key);
    }, true);

    form.addEventListener('submit', function () {
      start();
      state.submitAttempted = true;
      state.submittedAt = Date.now();
      dispatch(prefix + '_submit_attempted');
      setTag(prefix + '_time_to_submit', timeBucket(state.submittedAt - state.startedAt));
      writeTiming(prefix, state);
    }, true);
  }

  function trackExit() {
    window.addEventListener('pagehide', function () {
      Object.keys(active).forEach(function (prefix) {
        var state = active[prefix];
        if (state.startedAt && !state.success && !state.submitAttempted) {
          dispatch(prefix + '_exit_before_submit');
          setTag(prefix + '_exit_stage', state.lastStep || 'unknown');
        }
        writeTiming(prefix, state);
      });
    });
  }

  function bindForms() {
    bind(document.getElementById('commission-form'), 'commission');
    bind(document.getElementById('contact-band-form'), 'contact');
    flush();
  }

  emitJourneyContext();
  applyAttributionTags();
  trackGlobalLinks();
  trackExit();
  window.nhlFormFunnelTrack = dispatch;
  document.addEventListener('visitorConsentCollected', function () {
    applyAttributionTags();
    flush();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindForms, { once: true });
  else bindForms();

  var timer = setInterval(function () {
    flush();
    if (Date.now() - pageStartedAt > 60000) clearInterval(timer);
  }, 250);
})();
